<script setup>
import { useExpandableContent } from 'shared/composables/useExpandableContent';

defineProps({
  text: {
    type: String,
    default: '',
  },
});

const { contentElement, showReadMore, showReadLess, toggleExpanded } =
  useExpandableContent({ useResizeObserverForCheck: true });
</script>

<template>
  <span class="block py-1 text-xs font-medium text-polaris-foreground">
    {{ $t('SEARCH.TRANSCRIPT') }}
  </span>
  <div
    class="w-full break-words rounded-polaris-md pt-1 text-xs text-polaris-muted-foreground grid items-center"
    :class="showReadMore ? 'grid-cols-[1fr_auto]' : 'grid-cols-1'"
  >
    <div
      ref="contentElement"
      class="min-w-0"
      :class="{ 'overflow-hidden line-clamp-1': showReadMore }"
    >
      {{ text }}
      <button
        v-if="showReadLess"
        class="text-xs text-polaris-muted-foreground underline cursor-pointer bg-transparent border-0 p-0 hover:text-polaris-foreground font-medium ltr:ml-0.5 rtl:mr-0.5"
        @click.prevent.stop="toggleExpanded(false)"
      >
        {{ $t('SEARCH.READ_LESS') }}
      </button>
    </div>
    <button
      v-if="showReadMore"
      class="text-xs text-polaris-muted-foreground underline cursor-pointer bg-transparent border-0 p-0 hover:text-polaris-foreground font-medium justify-self-end ltr:ml-0.5 rtl:mr-0.5"
      @click.prevent.stop="toggleExpanded(true)"
    >
      {{ $t('SEARCH.READ_MORE') }}
    </button>
  </div>
</template>
